var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"orderNotesDetailsWrapper"},[_c('div',{staticClass:"row"},[_c('p',{staticClass:"order-notes",attrs:{"data-test":"order-notes"}},[_vm._v(" "+_vm._s(_vm.selectedOffer && _vm.selectedOffer.orderNotes ? _vm.selectedOffer.orderNotes : _vm.fallbackNote || '-')+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }